<template>
  <canvas class="rounded-2xl" id="webgl" />
</template>

<script>
import World from '../utils/webgl/World.js';

export default {
  name: 'Webgl',
  data() {
    return {
      world: null,
    };
  },
  methods: {
    newGround(ground) {
      this.world.setGroundColor(ground.map);
    },
  },
  mounted() {
    this.world = new World();
    this.$nextTick(() => {
      this.world.resize();
    });
  },
};
</script>
